<template>
    <div class="component-jobs">
        <ComponentJobsJob
            v-for="(job, index) in data.jobs"
            :key="index"
            :job="job"
        />
    </div>
</template>

<script setup lang="ts">
import type { ComponentJobsFragment } from '@/graphql/api'

import ComponentJobsJob from './ComponentJobsJob.vue'

defineProps<{
    data: ComponentJobsFragment
}>()
</script>

<style lang="scss" scoped>
.component-jobs {
    width: 100%;
    max-width: 1440px;
    padding: 0 20px;
    margin: 0 auto;
}
</style>
